<div class="content">
  <form #kontaktdatenDetailForm="ngForm" data-qa="kontakt-form">

    <header>
      <div>
      </div>

      <div class="buttons">

        <button matButton="outlined"
          data-qa="cancel-kontaktdaten-button"
          (click)="westnetzSidenavService.closeRightnav()">
          <mat-icon svgIcon="innogy_picto_close"></mat-icon>
          Schließen
        </button>

        <button matButton="filled"
          [disabled]="!kontaktdatenDetailForm.form.valid"
          data-qa="submit-kontaktdaten-button"
          (click)="saveKontaktdaten()">
          <mat-icon>save</mat-icon>
          {{createNew ? 'Anlegen' : 'Speichern'}}
        </button>

        @if (!createNew) {
          <button matButton="filled"
            class="button-warn"
            data-qa="delete-kontaktdaten-button"
            (click)="deleteKontaktdaten(kontaktdaten)">
            <mat-icon svgIcon="innogy_picto_bin_c-check"></mat-icon>
            Löschen
          </button>
        }

      </div>
    </header>

    <div class="detail-main">

      <fieldset>
        <legend>Kontaktdaten {{createNew ? 'anlegen' : 'editieren'}}</legend>

        <mat-form-field redispatchProvideReadonly>
          <mat-label>Name</mat-label>
          <input matInput
            maxlength="100"
            #nachname="ngModel"
            [(ngModel)]="kontaktdaten.name"
            id="name_{{kontaktdaten.id}}"
            name="name_{{kontaktdaten.id}}"
            data-qa="name"
            required/>
          @if (nachname?.errors?.required) {
            <mat-error>
              Bitte tragen Sie den Namen des Kontaktdaten ein
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field redispatchProvideReadonly>
          <mat-label>Adresse</mat-label>
          <input matInput
            maxlength="255"
            #adresse="ngModel"
            [(ngModel)]="kontaktdaten.adresse"
            id="adresse_{{kontaktdaten.id}}"
            name="adresse_{{kontaktdaten.id}}"
            data-qa="adresse"/>
        </mat-form-field>

        <h3>Kontaktinformationen</h3>

        @for (kontakt of kontaktdaten.kontakte; track kontakt; let i = $index) {
          <div class="row">
            <div class="column">
              <mat-form-field redispatchProvideReadonly>
                <mat-label>Typ</mat-label>
                <input matInput
                  maxlength="100"
                  #kontakttype="ngModel"
                  [(ngModel)]="kontakt.type"
                  id="kontaktdaten_{{kontaktdaten.id}}_kontakttype_{{i}}"
                  name="kontaktdaten_{{kontaktdaten.id}}_kontakttype_{{i}}"
                  [attr.data-qa]="'kontakttype_' + i"/>
                <mat-hint>Eine Beschreibung wie 'Telefon Notfall' oder 'E-Mail alternativ'</mat-hint>
              </mat-form-field>
            </div>
            <div class="column">
              <mat-form-field redispatchProvideReadonly>
                <mat-label>Wert</mat-label>
                <input matInput
                  maxlength="100"
                  #kontaktdata="ngModel"
                  [(ngModel)]="kontakt.data"
                  id="kontaktdaten_{{kontaktdaten.id}}_kontaktdata_{{i}}"
                  name="kontaktdaten_{{kontaktdaten.id}}_kontaktdata_{{i}}"
                  [attr.data-qa]="'kontaktdata_' + i"/>
                <mat-hint>Hier kann bspw. eine Telefonnummer oder eine E-Mail-Adresse stehen
                </mat-hint>
              </mat-form-field>
            </div>
          </div>
        }

        <button matButton="filled" (click)="addKontakt()" data-qa="add-contact-entry-button">Neuer Eintrag</button>

      </fieldset>
    </div>
  </form>
</div>
